module.exports = __webpack_public_path__ + "images/polestar2c19942de7ccb1170084638a8126cb8c.png";